export const TABLE_COLUMNS = [
    { name: 'File Name', value: 'name', isSortable: true },
    { name: 'Type', value: 'type', isSortable: true },
];

export const DEFAULT_TABLE_COLUMNS = ['name', 'type'];

export const SORT_QUERY_SELECTOR = 'sort';
export const PAGE_QUERY_SELECTOR = 'page';

export const DEFAULT_ITEMS_PER_PAGE = 25;

export const TABLE_INITIAL_QUERY = {
    page: 1,
    sortBy: 'name',
    sortByDir: 'desc',
};

